module.exports = __webpack_public_path__ + "static/hero7-f23ed4a04f078dc548bda3ebe092b881.webp";